import { Box } from "@chakra-ui/layout";
import { Modal } from "antd";
import FormGrupoDescontoGeral from "./FormGrupoDescontoGeral";
import useSaveGrupoDesconto from "core/features/grupo-desconto/hooks/useSaveGrupoDesconto";
import { showSuccess } from "infra/helpers/alerta";

interface ModalGrupoDescontoProps {
  isOpen: boolean;
  id?: string;
  onClose: () => any;
  loadingSave?: boolean;
  onSaved?: (id: string) => any;
}

function ModalGrupoDesconto({
  isOpen,
  id,
  onClose,
  onSaved,
}: ModalGrupoDescontoProps) {
  const { mutate, isLoading } = useSaveGrupoDesconto();

  return (
    <Modal width="800px" footer={null} visible={isOpen} onCancel={onClose}>
      <Box pt={4} pb={6}>
        <FormGrupoDescontoGeral
          id={id}
          onClose={onClose}
          onSave={(data) => {
            mutate(data, {
              onSuccess: (response) => {
                showSuccess().then(() => {
                  onClose();
                  onSaved?.(response.id);
                });
              },
            });
          }}
          isLoadingSave={isLoading}
        />
      </Box>
    </Modal>
  );
}

export default ModalGrupoDesconto;
